// Small, memory-only cache: nothing private is persisted in browser storage.
const TTL_MS = 2 * 60 * 1000;
const MAX_ENTRIES = 30;
const entries = new Map();
const pending = new Map();
let generation = 0;

export function sessionCacheKey(type, id, viewerId) {
  return JSON.stringify([type, id, viewerId || null]);
}

export function getSessionCache(key) {
  const entry = entries.get(key);
  if (!entry) return null;
  if (Date.now() - entry.savedAt >= TTL_MS) {
    entries.delete(key);
    return null;
  }
  return entry.value;
}

export function clearSessionCache() {
  generation += 1;
  entries.clear();
  pending.clear();
}

export function loadSessionData(key, loader) {
  const cached = getSessionCache(key);
  if (cached) return Promise.resolve(cached);
  if (pending.has(key)) return pending.get(key);
  const startedIn = generation;
  const request = Promise.resolve().then(loader).then((value) => {
    // A request started before logout or a mutation must not restore old data.
    if (generation === startedIn && value) {
      entries.delete(key);
      entries.set(key, { value, savedAt: Date.now() });
      if (entries.size > MAX_ENTRIES) entries.delete(entries.keys().next().value);
    }
    return value;
  }).finally(() => {
    if (pending.get(key) === request) pending.delete(key);
  });
  pending.set(key, request);
  return request;
}
